/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_ClaimingInputs */

const en_domain_search_modal_claiming = /** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claiming...`)
};

const es_domain_search_modal_claiming = /** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamando...`)
};

const fr_domain_search_modal_claiming = /** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamation en cours...`)
};

const de_domain_search_modal_claiming = /** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird beansprucht...`)
};

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const ja_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const zh_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const ar_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const id_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const it_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const ru_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const pt_domain_search_modal_claiming = en_domain_search_modal_claiming;

/** @type {(inputs: Domain_Search_Modal_ClaimingInputs) => LocalizedString} */
const ko_domain_search_modal_claiming = en_domain_search_modal_claiming;

/**
* | output |
* | --- |
* | "Claiming..." |
*
* @param {Domain_Search_Modal_ClaimingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_claiming = /** @type {((inputs?: Domain_Search_Modal_ClaimingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_ClaimingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_claiming(inputs)
	if (locale === "es") return es_domain_search_modal_claiming(inputs)
	if (locale === "fr") return fr_domain_search_modal_claiming(inputs)
	if (locale === "de") return de_domain_search_modal_claiming(inputs)
	if (locale === "ja") return ja_domain_search_modal_claiming(inputs)
	if (locale === "zh") return zh_domain_search_modal_claiming(inputs)
	if (locale === "ar") return ar_domain_search_modal_claiming(inputs)
	if (locale === "id") return id_domain_search_modal_claiming(inputs)
	if (locale === "it") return it_domain_search_modal_claiming(inputs)
	if (locale === "ru") return ru_domain_search_modal_claiming(inputs)
	if (locale === "pt") return pt_domain_search_modal_claiming(inputs)
	return ko_domain_search_modal_claiming(inputs)
});